import React, {useMemo} from 'react';
import LeafletPolyline from "@ui/leafletCustom/leafletPolyline/LeafletPolyline";
import {LeafletMouseEvent} from "leaflet";
import {LatLngCor} from "@ui/leafletCustom/types/latLng";
import {ILeafletPolylinePathOptions} from "@ui/leafletCustom/types/polilyne";
import {
    onClickPolylineCorrectionPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/types/events";


const PATH_OPTIONS: ILeafletPolylinePathOptions = {
    weight: 8
}

interface IProps {
    positions: LatLngCor[],
    onClickPolyline: onClickPolylineCorrectionPointsSingleVoyage
}


const PolylineDraggableCorrectionPointsSingleVoyage = ({
                                                           positions,
                                                           onClickPolyline,
                                                       }: IProps) => {

    const eventHandlersPolyline = useMemo(() => ({
        click(event: LeafletMouseEvent) {
            onClickPolyline({
                lat: event.latlng.lat,
                lng: event.latlng.lng,
            })
        }
    }), [onClickPolyline])

    return (
        <LeafletPolyline
            positions={positions}
            pathOptions={PATH_OPTIONS}
            eventHandlers={eventHandlersPolyline}
        />
    )

};

export default PolylineDraggableCorrectionPointsSingleVoyage;